import axios from 'axios';
import { useCallback } from 'react';
import { useDispatch, useSelector, shallowEqual } from 'react-redux';
import { API_REQUEST_URL } from '../../../common/apiConfig';
import {
  REPORTS_FETCH_SUMMARY_DATA_BY_SITE_BEGIN,
  REPORTS_FETCH_SUMMARY_DATA_BY_SITE_SUCCESS,
  REPORTS_FETCH_SUMMARY_DATA_BY_SITE_FAILURE,
  REPORTS_FETCH_SUMMARY_DATA_BY_SITE_DISMISS_ERROR,
} from './constants';

export function fetchSummaryDataBySite(args = {}) {
  return (dispatch,getState) => { // optionally you can have getState as the second argument
    dispatch({
      type: REPORTS_FETCH_SUMMARY_DATA_BY_SITE_BEGIN,
    });

    const promise = new Promise((resolve, reject) => {
      const cognitoIdToken = getState().home.auth.cognitoIdToken;
      const token = `Bearer ${cognitoIdToken}`;
      let conditions = args;
      if(args.sortedBy === undefined || args.sortedBy === null) {
        conditions = {
          ...conditions,
          sort: "ascend",
          sortedBy: "site",
        }
      }
      const doRequest = axios.post(`${API_REQUEST_URL}/getSalesSummaryInSite`, conditions, {
        headers: {
          'Authorization': token,
        }
      });
      doRequest.then(
        (res) => {
          dispatch({
            type: REPORTS_FETCH_SUMMARY_DATA_BY_SITE_SUCCESS,
            data: {
              data: res.data.data,
              totals: res.data.totals,
              summary: res.data && res.data.summary,
            },
          });
          resolve(res);
        },
        // Use rejectHandler as the second argument so that render errors won't be caught.
        (err) => {
          const errorMsg = err && err.response ? err.response.data.message : 'There is an error. Please refresh page or contact administrator.';
          dispatch({
            type: REPORTS_FETCH_SUMMARY_DATA_BY_SITE_FAILURE,
            data: { error: errorMsg },
          });
          reject(err);
        },
      );
    });

    return promise;
  };
}

export function dismissFetchSummaryDataBySiteError() {
  return {
    type: REPORTS_FETCH_SUMMARY_DATA_BY_SITE_DISMISS_ERROR,
  };
}

export function useFetchSummaryDataBySite() {
  const dispatch = useDispatch();

  const { fetchSummaryDataBySitePending, fetchSummaryDataBySiteError } = useSelector(
    state => ({
      fetchSummaryDataBySitePending: state.reports.fetchSummaryDataBySitePending,
      fetchSummaryDataBySiteError: state.reports.fetchSummaryDataBySiteError,
    }),
    shallowEqual,
  );

  const boundAction = useCallback((...args) => {
    return dispatch(fetchSummaryDataBySite(...args));
  }, [dispatch]);

  const boundDismissError = useCallback(() => {
    return dispatch(dismissFetchSummaryDataBySiteError());
  }, [dispatch]);

  return {
    fetchSummaryDataBySite: boundAction,
    fetchSummaryDataBySitePending,
    fetchSummaryDataBySiteError,
    dismissFetchSummaryDataBySiteError: boundDismissError,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case REPORTS_FETCH_SUMMARY_DATA_BY_SITE_BEGIN:
      // Just after a request is sent
      return {
        ...state,
        fetchSummaryDataBySitePending: true,
        fetchSummaryDataBySiteError: null,
      };

    case REPORTS_FETCH_SUMMARY_DATA_BY_SITE_SUCCESS:
      // The request is success
      return {
        ...state,
        reportsSiteData: action.data.data,
        reportsSiteTotals: action.data.totals,
        siteSummary: action.data.summary,
        fetchSummaryDataBySitePending: false,
        fetchSummaryDataBySiteError: null,
      };

    case REPORTS_FETCH_SUMMARY_DATA_BY_SITE_FAILURE:
      // The request is failed
      return {
        ...state,
        fetchSummaryDataBySitePending: false,
        fetchSummaryDataBySiteError: action.data.error,
      };

    case REPORTS_FETCH_SUMMARY_DATA_BY_SITE_DISMISS_ERROR:
      // Dismiss the request failure error
      return {
        ...state,
        fetchSummaryDataBySiteError: null,
      };

    default:
      return state;
  }
}
